import { useHistory } from "react-router";

const IntroductionPage = () => {
  const history = useHistory();
  return (
    <main id="welcome-page" className="container mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow-md p-4 sm:p-8 flex flex-col lg:flex-row">
        <div className="w-full lg:w-1/2 lg:pr-8 mb-6 lg:mb-0">
          <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">Bienvenue sur ProDrive</h2>
          <p className="text-neutral-600 mb-6 sm:mb-8 text-sm sm:text-base">
            Préparez-vous à tester vos connaissances sur les règles essentielles de sécurité routière et le fonctionnement des véhicules. Notre plateforme de quiz intuitive est conçue pour vous assurer une bonne préparation à votre test d'intégration en tant que conducteur.
          </p>

          <div id="features" className="space-y-4 mb-6 sm:mb-8">
            <div className="flex items-start space-x-3">
              <div className="w-5 h-5 sm:w-6 sm:h-6 bg-neutral-300 rounded-full flex-shrink-0 mt-1"></div>
              <p className="text-neutral-700 text-sm sm:text-base">
                Base de questions complète couvrant tous les aspects de la conduite
              </p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="w-5 h-5 sm:w-6 sm:h-6 bg-neutral-300 rounded-full flex-shrink-0 mt-1"></div>
              <p className="text-neutral-700 text-sm sm:text-base">
                Retour immédiat
              </p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="w-5 h-5 sm:w-6 sm:h-6 bg-neutral-300 rounded-full flex-shrink-0 mt-1"></div>
              <p className="text-neutral-700 text-sm sm:text-base">
                Obtention de certificat de reussite
              </p>
            </div>
          </div>

          <button 
            className="btn-primary w-full sm:w-auto"
            onClick={() => history.push("/test")}
          >
            Commencer le Test
          </button>
        </div>

        <div className="w-full lg:w-1/2 mt-6 lg:mt-0">
          <div className="bg-neutral-300 h-48 sm:h-64 lg:h-full rounded-lg flex items-center justify-center">
            <img
              src="https://prodrive-uploads.s3.eu-west-3.amazonaws.com/a-man-in-a-yellow-vest-is-handing-a-piece-of-paper.jpg"
              alt="Introduction Page"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>

      <div id="chapters-preview" className="mt-8 sm:mt-12 hidden">
        <h3 className="text-xl sm:text-2xl font-semibold mb-4 sm:mb-6">Chapitres du Quiz</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          <div className="bg-white p-4 sm:p-6 rounded-lg shadow-sm">
            <h4 className="font-semibold mb-2 text-base sm:text-lg">Panneaux de Signalisation</h4>
            <p className="text-neutral-600 text-xs sm:text-sm mb-4">
              Apprenez à reconnaître et comprendre les différents panneaux de signalisation.
            </p>
            <div className="w-full bg-neutral-200 rounded-full h-2">
              <div className="bg-neutral-600 h-2 rounded-full w-1/4"></div>
            </div>
          </div>
          <div className="bg-white p-4 sm:p-6 rounded-lg shadow-sm">
            <h4 className="font-semibold mb-2 text-base sm:text-lg">Règles de Circulation</h4>
            <p className="text-neutral-600 text-xs sm:text-sm mb-4">
              Maîtrisez les règles de circulation essentielles pour une conduite sûre.
            </p>
            <div className="w-full bg-neutral-200 rounded-full h-2">
              <div className="bg-neutral-600 h-2 rounded-full w-2/5"></div>
            </div>
          </div>
          <div className="bg-white p-4 sm:p-6 rounded-lg shadow-sm">
            <h4 className="font-semibold mb-2 text-base sm:text-lg">Fonctionnement des Véhicules</h4>
            <p className="text-neutral-600 text-xs sm:text-sm mb-4">
              Apprenez les bases du fonctionnement et de l'entretien des véhicules.
            </p>
            <div className="w-full bg-neutral-200 rounded-full h-2">
              <div className="bg-neutral-600 h-2 rounded-full w-[10%]"></div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default IntroductionPage;
